import React from 'react';
import { AssetsActionButton } from '@/components/assets/AssetsActionButton';

interface AssetsHeaderProps {
  assets: any[];
  onAddAsset: () => void;
  onBuildPortfolio: () => void;
  onAiImport: () => void;
}

export function AssetsHeader({ assets, onAddAsset, onBuildPortfolio, onAiImport }: AssetsHeaderProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-3">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold">Assets</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Manage and view all your assets in one place
        </p>
      </div>
      <div className="flex w-full sm:w-auto items-center gap-2 self-start">
        <AssetsActionButton 
          onAddAsset={onAddAsset}
          assets={assets}
          onBuildPortfolio={onBuildPortfolio}
          onAiImport={onAiImport}
        />
      </div>
    </div>
  );
}

export default AssetsHeader;
